import ConfirmStageStyled from './ConfirmStageStyled';
import ErrorMessage from '../message/ErrorMessage';
import Message from '../message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import RedeemActions from '../../actions/RedeemActions';
import RedeemContainer from './RedeemContainer';
import SquareButton from '../squareButton/SquareButton';
import epicTracking from 'epic-tracking';
import {withRouter} from 'react-router';

class ConfirmStage extends React.Component {
  static propTypes = {
    pageMapping: PropTypes.string,
    redeemStore: PropTypes.object,
    nextStage: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    config: PropTypes.object,
  };

  /**
   * Attempt to add code to user's account
   */
  handleSend = () => {
    const submitData = {
      hostPageId: this.props.pageMapping,
      redeemCode: this.props.redeemStore.redeemCode,
      isLoggedIn: this.props.isLoggedIn,
    };
    RedeemActions.redeemCode(submitData);
    RedeemActions.setNextStage(this.props.nextStage);
  };

  handleSubmit = () => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'RedeemConfirm',
      eventAction: 'send',
    });
    this.handleSend();
  };

  /**
   * Wipe all data from RedeemStore and go back to the first stage of the flow
   */
  handleReset = () => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'RedeemConfirm',
      eventAction: 'reset',
    });
    RedeemActions.resetFlow.defer();
  };

  handleRetry = () => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'RedeemConfirm',
      eventAction: 'retry',
    });
    this.handleSend();
  };

  render() {
    const {
      redeemStore: {redeemError},
      config,
    } = this.props;
    const msgConfig = config.messages || {};
    const {errorMsgHandler} = config;

    let confirmStageView; //content to render
    const resetButton = (
      <SquareButton
        handleClick={this.handleReset}
        config={{buttonStyle: 'btn-default', inline: true, fixedWidth: true}}>
        <Message code="epic.common.reset" />
      </SquareButton>
    );

    const retryButton = (
      <SquareButton
        handleClick={this.handleSubmit}
        config={{buttonStyle: 'btn-primary', inline: true, fixedWidth: true}}>
        <Message code="epic.common.retry" />
      </SquareButton>
    );

    const submitButton = (
      <SquareButton
        handleClick={this.handleSubmit}
        config={{buttonStyle: 'btn-primary', inline: true, fixedWidth: true}}>
        <Message code="epic.common.activate" />
      </SquareButton>
    );

    // Default
    const confirmMessageProps = {
      code: 'epic.code.redemption.confirm.msg',
    };

    // FN Crew (One Month Access) gets custom confirm message.
    const entitlementName =
      typeof this.props.redeemStore.entitlementName === 'string'
        ? this.props.redeemStore.entitlementName.toLowerCase()
        : '';
    if (entitlementName === 'fn_crew') {
      confirmMessageProps.code = 'epic.code.redemption.confirm.msg.fnCrew';
      confirmMessageProps.args = [
        'https://legal.epicgames.com/store/eula',
        'https://legal.epicgames.com/fortnite/crew-offer-terms',
      ];
    }

    if (this.props.redeemStore.loading) {
      confirmStageView = <div className="redeemLoading" />;
    } else if (this.props.redeemStore.redeemError) {
      let errorData;
      const displayMetadata = [4002, 4001].includes(redeemError.numericErrorCode);
      if (displayMetadata) {
        errorData = (
          <div className="redeemInfo">
            <div className="itemTitle">{this.props.redeemStore.title}</div>
            <div className="itemDescription">{this.props.redeemStore.description}</div>
          </div>
        );
      } else {
        errorData = (
          <div className="errorData">
            <div className="errorPrimary">
              <Message code="epic.code.redemption.confirm.code_intro" />
            </div>
            <div className="errorSecondary">{this.props.redeemStore.redeemCode}</div>
          </div>
        );
      }
      // error view
      confirmStageView = (
        <div>
          <h1 className="site-block-page-title">
            <Message
              code={
                msgConfig['epic.code.redemption.confirm.title'] ||
                'epic.code.redemption.confirm.title'
              }
            />
          </h1>
          <div className="site-block">
            <div className="site-block-header">
              <h1 className="site-block-title">
                <Message code="errors.com.epicgames.code.redemption.error" />
              </h1>
              <div className="clearfix" />
            </div>
            {errorData}
            <p className="centered">
              {errorMsgHandler ? (
                errorMsgHandler(redeemError, ErrorMessage)
              ) : (
                <ErrorMessage
                  className="errorMessage"
                  msg={redeemError.message}
                  args={[redeemError.args]}
                />
              )}
            </p>
            <div className="buttonContainer row">
              <div className="col-sm-6">{resetButton}</div>
              <div className="col-sm-6">{retryButton}</div>
            </div>
          </div>
        </div>
      );
      /**
       * RENDER VIEW: Primary/default view
       */
    } else {
      confirmStageView = (
        <div>
          <h1 className="site-block-page-title">
            <Message
              code={
                msgConfig['epic.code.redemption.confirm.title'] ||
                'epic.code.redemption.confirm.title'
              }
            />
          </h1>
          <div className="site-block">
            <div className="site-block-header">
              <h1 className="site-block-title">
                <Message code="epic.code.redemption.confirm.subtitle" />
              </h1>
              <div className="clearfix" />
            </div>
            <div className="redeemInfo">
              <div className="itemTitle">{this.props.redeemStore.title}</div>
              <div className="itemDescription">{this.props.redeemStore.description}</div>
            </div>
            <hr />
            <p className="centered">
              <Message {...confirmMessageProps} />
            </p>
            <div className="buttonContainer row">
              <div className="col-sm-6">{resetButton}</div>
              <div className="col-sm-6">{submitButton}</div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <ConfirmStageStyled className="confirmStage">
        <RedeemContainer className="redeemContainer">{confirmStageView}</RedeemContainer>
      </ConfirmStageStyled>
    );
  }
}

export default withRouter(ConfirmStage);
